import tippy from 'tippy.js';

tippy('.tooltip');
